import React from 'react'
import Modal from '@retracedgmbh/ui-components-lib/Modal'
import useTranslator from '@/hooks/useTranslator'

const TModal = ({okButtonProps, cancelButtonProps, children, ...props}) => {
  const {getTranslation} = useTranslator({page: 'ui-components'})
  return (
    <Modal
      okButtonProps={{
        title: getTranslation('modal.okButtonText'),
        variant: 'fill',
        color: 'primary',
        ...okButtonProps,
      }}
      cancelButtonProps={{
        title: getTranslation('modal.cancelButtonText'),
        color: 'danger',
        ...cancelButtonProps,
      }}
      {...props}
    >
      {children}
    </Modal>
  )
}

export default TModal
